import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "searchbar-dropdown-item-content" }
const _hoisted_3 = {
  class: "xusericon",
  "data-size": "small"
}
const _hoisted_4 = { class: "xusericon-picture" }
const _hoisted_5 = { class: "header-search-dropdown-result" }
const _hoisted_6 = ["title"]

import { useSearchPageStore } from "@/store/store/searchPageStore";
import { computed } from "vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";

interface Props {
  pageName: string;
  result: CertificationSearchResultModel | DisbursementSearchResultModel;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchBarDropdownResult',
  props: {
    pageName: { default: "" },
    result: {}
  },
  setup(__props: any) {

const props = __props;

const href = computed<string>(() => getResultUrl(props.result));

const searchPageStore = useSearchPageStore();

function handleDropdownResultClick() {
  searchPageStore.handleSearchResultClick(props.result, props.pageName);
}

function getResultUrl(
  result: CertificationSearchResultModel | DisbursementSearchResultModel
) {
  const page = props.pageName;
  const id = searchPageStore.getRouteIdentifier(page, result);
  return `/${page}/${id}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: href.value,
    onClick: _withModifiers(handleDropdownResultClick, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.result?.borrowerInitials), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", null, _toDisplayString(__props.result.borrowerName || "No Name"), 1),
        _createElementVNode("h5", {
          title: __props.result.lenderName
        }, _toDisplayString(__props.result.lenderName), 9, _hoisted_6)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})